var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachFileBlueIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.983,
    height: 7.277,
    viewBox: "0 0 21.983 8.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5D5FEF",
    d: "M28.684 43.027h10.4a.809.809 0 1 1 0 1.618h-10.4a.809.809 0 0 1 0-1.618zm2.779 3.4h-4.495a2.52 2.52 0 1 1 0-5.041h4.45a.809.809 0 1 0 0-1.618h-4.45a4.138 4.138 0 1 0 0 8.277h4.494a.809.809 0 1 0 0-1.618zm9.211-6.659h-4.426a.809.809 0 0 0 0 1.618H40.7a2.52 2.52 0 1 1 0 5.041h-4.52a.809.809 0 0 0 0 1.618h4.494a4.138 4.138 0 1 0 0-8.277z",
    transform: "translate(-139.83 -30.77) translate(117 -9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFileBlueIcon);
export default __webpack_public_path__ + "static/media/AttachFileBlueIcon.db0e0582aa67fc453c457b5cf8a82c23.svg";
export { ForwardRef as ReactComponent };